import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/Data.context";
import { useNavigate } from "react-router-dom";
import Device from "../../components/Device/Device.component";

const ListReaders = () => {
  // const _window: any = window.navigator;
  const navigate: any = useNavigate();
  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    _getReaders();

    setData({
      ...data,
      pageHeader: {
        title: "Metrix Readers",
        backButton: false,
        actionButton: true,
        nextPage: "/pairReader",
      },
    });
  }, []);

  const [readers, setReaders] = useState([] as any[]);
  const _getReaders = () => {
    const storageKey = "readers";
    const readersStorage: any = localStorage.getItem(storageKey);
    if (readersStorage) {
      const readers: any = JSON.parse(readersStorage);
      setReaders(readers);
      return;
    }
  };

  return <>
    {readers.length === 0 && <>
      <div className="text-center">
        <strong>No readers found</strong>
      </div>
    </>}

    {readers.length > 0 && <>
      <ul className="list-group">
        {readers.map((reader: any, index: number) => 
          <React.Fragment key={`list-readers-${reader.id}-${index}`}>
            <Device reader={reader}
              action="open_details"
              onClick={() => navigate(`/readers/${reader.hashId}`)} />
          </React.Fragment>
          )}
      </ul>
    </>}
  </>
};

export default ListReaders;